import ContractVersion from './contract-version.entity';

export default class ContractVersionHistory {
  id: string;

  customerId: string;

  customerName: string;

  contractNumber: string;

  versions: ContractVersion[];

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.customerId = obj.customerId || '';
    this.customerName = obj.customerName || '';
    this.contractNumber = obj.contractNumber || '';
    this.versions = obj.versions ? ContractVersion.ofList(obj.versions) : [];
  }

  public static of(obj: any = {}): ContractVersionHistory {
    return new ContractVersionHistory(obj);
  }
}
